import Vue from "vue";
import Hotjar from "vue-hotjar";

Vue.use (Hotjar, {
    id: process.env.VUE_APP_HOTJAR_ID,
    isProduction: Boolean(parseInt(process.env.VUE_APP_HOTJAR_IS_PRODUCTION))
})
